/* BIRDLINE — the flock.
   ------------------------------------------------------------------------
   Ported from birdline-flight-test.html. Geometry and keyframes match the
   reference exactly; do not "improve" them without re-running that file
   side by side.

   The failure mode this avoids is birds that read as flickering sticks. Four
   things prevent it and all four are required:

     1. The wing has two segments. The inner (arm/secondaries) pivots at the
        shoulder; the outer (hand/primaries) is nested inside it and pivots at
        the elbow, overlapping the inner by ~2 units so no gap ever opens mid
        stroke. The whole wing group is scaled 0.84 about the shoulder so the
        span does not overrun the tail.
     2. The outer wing LAGS the inner — same timeline, different curve. This
        single detail is the difference between flight and a windshield wiper.
     3. The body bobs in time with the stroke, ±1.3px, peaking on the
        downstroke. A body that holds still while wings move reads as a puppet.
     4. The flap rate changes with flight phase: hard on takeoff, settling once
        there is altitude. Randomised per bird so eleven are never in sync.

   Colors are the confetti palette, per Darius. Cream (#F6F1E7) is in that
   palette and is all but invisible against the cream drawer, so cream birds —
   and only cream birds — carry a hairline forest stroke to hold their
   silhouette. Say the word and it comes off.
   ------------------------------------------------------------------------ */
(function () {
  var BL = (window.BL = window.BL || {});

  var NS = 'http://www.w3.org/2000/svg';

  /* The confetti palette, unchanged, from the celebration this replaces. */
  var COLORS = ['#C85A1A', '#E0762E', '#C9A227', '#F6F1E7', '#8FA98F', '#1F3A2A'];
  var NEEDS_OUTLINE = { '#F6F1E7': '#1F3A2A' };

  var MAX_NODES = 12;
  var FLOCK = 11;

  function reduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* One bird. 32x19 at rest — check the silhouette at actual size, not zoomed:
     bill, head, body and forked tail all have to read at that scale. */
  function birdSVG(fill) {
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '0 0 58 34');
    svg.setAttribute('width', '32');
    svg.setAttribute('height', '19');
    svg.setAttribute('aria-hidden', 'true');

    var stroke = NEEDS_OUTLINE[fill]
      ? ' stroke="' + NEEDS_OUTLINE[fill] + '" stroke-width="0.6" stroke-linejoin="round"'
      : '';

    function wing(op, delay) {
      return '' +
        '<g transform="translate(34,15.5) scale(.84) translate(-34,-15.5)">' +
          '<g class="bl-bird__w-in" style="transform-origin:34px 15.5px;opacity:' + op + ';animation-delay:' + delay + '">' +
            '<path d="M34 15.5' +
                    ' C29.4 12.4, 24.2 10.4, 19.2 10.0' +
                    ' C18.4 11.6, 18.0 13.0, 18.2 14.4' +
                    ' C23.0 15.6, 28.6 17.6, 33.4 19.2' +
                    ' C34.2 18.0, 34.4 16.6, 34 15.5 Z" fill="' + fill + '"' + stroke + '/>' +
            '<g class="bl-bird__w-out" style="transform-origin:19.2px 10.6px;animation-delay:' + delay + '">' +
              '<path d="M21.4 11.4' +
                      ' C15.8 8.0, 10.2 5.4, 4.6 4.4' +
                      ' C4.1 5.2, 4.3 6.3, 5.1 7.2' +
                      ' C9.9 9.0, 15.0 11.6, 19.8 14.4' +
                      ' C20.9 13.6, 21.5 12.5, 21.4 11.4 Z" fill="' + fill + '"' + stroke + '/>' +
            '</g>' +
          '</g>' +
        '</g>';
    }

    svg.innerHTML = '' +
      '<g class="bl-bird__body">' +
        /* far wing first, faded and phase-shifted: without it the bird reads
           as a flat cutout rather than something with two sides */
        '<g transform="translate(1.8,1.6)">' + wing(0.45, '-0.055s') + '</g>' +
        '<path d="M44.8 14.6' +
                ' C48.6 15.2, 50.4 15.7, 51.5 16.7' +
                ' C53.0 17.0, 54.8 17.3, 56.4 17.7' +
                ' C54.8 18.3, 53.0 18.5, 51.4 18.4' +
                ' C50.1 19.5, 48.3 20.0, 46.3 19.8' +
                ' C41.5 20.8, 34.0 20.9, 27.5 19.6' +
                ' C24.6 19.0, 22.2 18.2, 20.6 17.4' +
                ' C17.6 18.4, 13.8 19.1, 10.0 19.3' +
                ' C12.8 17.9, 15.6 16.7, 18.0 15.3' +
                ' C16.2 14.4, 14.4 13.3, 12.9 12.2' +
                ' C15.8 12.9, 18.6 13.8, 21.0 14.7' +
                ' C27.4 13.7, 38.6 13.4, 44.8 14.6 Z" fill="' + fill + '"' + stroke + '/>' +
        wing(1, '0s') +
      '</g>';
    return svg;
  }

  /* The flock launches from BEHIND the checkout button on purpose: the flight
     path is a directional pointer at the Shop All button above, not a
     decoration. Do not move the origin. */
  BL.flyBirds = function (opts) {
    var o = opts || {};
    if (reduced()) return;

    var button = o.button || document.querySelector('.bl-drawer .bl-checkout') ||
                 document.querySelector('.bl-checkout');
    if (!button) return;

    var host = o.host || button.closest('form') || button.parentNode;
    if (!host || !host.animate) return;

    var old = host.querySelector('.bl-confetti');
    if (old) old.remove();

    var layer = document.createElement('div');
    layer.className = 'bl-confetti bl-flight';
    layer.setAttribute('aria-hidden', 'true');

    var hb = host.getBoundingClientRect();
    var bb = button.getBoundingClientRect();
    var ox = bb.left - hb.left + bb.width / 2;
    var oy = bb.top - hb.top + bb.height / 2;

    host.appendChild(layer);

    var n = Math.min(FLOCK, MAX_NODES);
    for (var i = 0; i < n; i++) {
      var el = document.createElement('div');
      el.className = 'bl-bird';
      el.appendChild(birdSVG(COLORS[i % COLORS.length]));

      var scale = 0.62 + Math.random() * 0.5;
      var dir = i % 2 ? 1 : -1;                          /* alternate so the group fans */
      var spread = (0.35 + Math.random() * 0.9) * dir;
      var rise = 190 + Math.random() * 150;
      var flap = (118 + Math.random() * 26) + 'ms';      /* launch flap rate */

      el.style.left = ox + 'px';
      el.style.top = oy + 'px';
      el.style.setProperty('--bl-flap', flap);
      el.style.opacity = 0;
      layer.appendChild(el);

      /* Three phases: burst climb to ~18%, cruise arc to ~55%, then bank away
         and fade. Banking is part of the flight keyframes, not a separate
         effect — a bird that turns without banking looks driven, not flown. */
      var kf = [
        { transform: 'translate(-50%,-50%) translate(0px,0px) rotate(0deg) scale(' + (scale * 0.5) + ')', opacity: 0, offset: 0 },
        { transform: 'translate(-50%,-50%) translate(' + (spread * 22) + 'px,-38px) rotate(' + (dir * -8) + 'deg) scale(' + scale + ')', opacity: 1, offset: 0.18 },
        { transform: 'translate(-50%,-50%) translate(' + (spread * 68) + 'px,' + (-rise * 0.62) + 'px) rotate(' + (dir * -16) + 'deg) scale(' + scale + ')', opacity: 1, offset: 0.55 },
        { transform: 'translate(-50%,-50%) translate(' + (spread * 126) + 'px,' + (-rise) + 'px) rotate(' + (dir * -30) + 'deg) scale(' + (scale * 0.92) + ')', opacity: 0, offset: 1 }
      ];

      var anim = el.animate(kf, {
        duration: 1320 + Math.random() * 380,
        delay: i * 28,
        easing: 'cubic-bezier(.22,.62,.30,1)',
        fill: 'forwards'
      });

      /* Birds beat hard on takeoff and settle once they have altitude. */
      (function (node, index) {
        setTimeout(function () {
          node.style.setProperty('--bl-flap', (215 + Math.random() * 70) + 'ms');
        }, index * 28 + 430);
      })(el, i);

      anim.onfinish = (function (node) {
        return function () { if (node.parentNode) node.remove(); };
      })(el);
    }

    /* Belt and braces: onfinish does not fire in a backgrounded tab. */
    setTimeout(function () { if (layer.parentNode) layer.remove(); }, 2200);
  };

  /* ---- rung two: the flock that points at Shop All ---------------------- */

  /* Rung one's birds fly UP and away, because clearing free shipping is a
     moment with nowhere to go. Rung two has somewhere to go: the Shop All
     button sitting at the top of the drawer, which is the whole point of the
     rung. So this flight is aimed rather than scattered — it starts behind the
     checkout button and lands on the button we want looked at.

     A FIXED layer, not an absolute one inside the drawer: the two ends of this
     flight live in different scroll containers, and anything positioned inside
     the drawer would be clipped the moment it left the footer. Viewport
     coordinates are the only frame both ends share. */
  BL.flyBirdsTo = function (opts) {
    var o = opts || {};
    if (reduced()) return;

    var from = o.from || document.querySelector('.bl-drawer .bl-checkout');
    var to = o.to || document.querySelector('.bl-shopall');
    if (!from || !to || !document.body.animate) return;

    var a = from.getBoundingClientRect();
    var b = to.getBoundingClientRect();
    if (!a.width || !b.width) return;

    /* Flying at something the shopper cannot see is worse than not flying at
       all — it spends the moment on an empty patch of screen. The caller is
       expected to scroll the target into view first; if it still is not on
       screen, stand down. */
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var vw = window.innerWidth || document.documentElement.clientWidth;
    if (b.bottom < 0 || b.top > vh || b.right < 0 || b.left > vw) return;

    var old = document.querySelector('.bl-flight--aimed');
    if (old) old.remove();

    var layer = document.createElement('div');
    layer.className = 'bl-confetti bl-flight bl-flight--aimed';
    layer.setAttribute('aria-hidden', 'true');
    document.body.appendChild(layer);

    var ox = a.left + a.width / 2;
    var oy = a.top + a.height / 2;
    var dx = (b.left + b.width / 2) - ox;
    var dy = (b.top + b.height / 2) - oy;

    var n = Math.min(FLOCK, MAX_NODES);
    for (var i = 0; i < n; i++) {
      var el = document.createElement('div');
      el.className = 'bl-bird';
      el.appendChild(birdSVG(COLORS[i % COLORS.length]));

      var scale = 0.6 + Math.random() * 0.45;
      var dir = i % 2 ? 1 : -1;
      /* The fan is lateral only. Every bird still has to arrive, so the spread
         is spent in the middle of the flight and closed by the end. */
      var spread = (18 + Math.random() * 54) * dir;
      var bow = 30 + Math.random() * 55;          /* how far the arc bellies out */
      var flap = (118 + Math.random() * 26) + 'ms';

      el.style.left = ox + 'px';
      el.style.top = oy + 'px';
      el.style.setProperty('--bl-flap', flap);
      el.style.opacity = 0;
      layer.appendChild(el);

      var kf = [
        { transform: 'translate(-50%,-50%) translate(0px,0px) rotate(0deg) scale(' + (scale * 0.5) + ')', opacity: 0, offset: 0 },
        { transform: 'translate(-50%,-50%) translate(' + (spread * 0.5) + 'px,' + (dy * 0.14 - 22) + 'px) rotate(' + (dir * -10) + 'deg) scale(' + scale + ')', opacity: 1, offset: 0.16 },
        { transform: 'translate(-50%,-50%) translate(' + (dx * 0.5 + spread) + 'px,' + (dy * 0.5 - bow) + 'px) rotate(' + (dir * -14) + 'deg) scale(' + scale + ')', opacity: 1, offset: 0.58 },
        { transform: 'translate(-50%,-50%) translate(' + dx + 'px,' + dy + 'px) rotate(0deg) scale(' + (scale * 0.7) + ')', opacity: 0, offset: 1 }
      ];

      var anim = el.animate(kf, {
        duration: 980 + Math.random() * 260,
        delay: i * 26,
        easing: 'cubic-bezier(.3,.55,.35,1)',
        fill: 'forwards'
      });

      /* Same phase change as rung one: hard beats out of the gate, settling
         into a cruise once they are underway. */
      (function (node, index) {
        setTimeout(function () {
          node.style.setProperty('--bl-flap', (215 + Math.random() * 70) + 'ms');
        }, index * 26 + 380);
      })(el, i);

      anim.onfinish = (function (node) {
        return function () { if (node.parentNode) node.remove(); };
      })(el);
    }

    setTimeout(function () { if (layer.parentNode) layer.remove(); }, 2200);
  };
})();
